var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-link',_vm._g(_vm._b({staticClass:"link-forget-password",attrs:{"to":{ name: 'ForgotPassword' }}},'b-link',_vm.$attrs,false),_vm.$listeners),[_vm._v("\n    "+_vm._s(_vm.$t('text'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }